/** Display helpers for admin notice list cards. */

import { htmlToPlainText } from "./noticeBodyHtml";

export function formatNoticeCardDate(dateString: string): string {
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const noticeDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    const timeStr = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    if (noticeDay.getTime() === today.getTime()) {
      return `Today at ${timeStr}`;
    }

    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (noticeDay.getTime() === yesterday.getTime()) {
      return `Yesterday at ${timeStr}`;
    }

    const datePart = date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: date.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
    });
    return `${datePart} at ${timeStr}`;
  } catch {
    return dateString;
  }
}

/** File name for UI — strips Drive-style folder prefixes. */
export function getAttachmentDisplayName(name: string): string {
  const trimmed = (name || "").trim();
  if (!trimmed) return "Attachment";
  const parts = trimmed.split(/[/\\]/);
  return parts[parts.length - 1] || trimmed;
}

export function truncateNoticeBody(text: string, maxLength: number): string {
  const plain = htmlToPlainText(text || "").trim();
  if (!plain || plain.length <= maxLength) return plain;
  return `${plain.slice(0, maxLength).trim()}…`;
}

/** Skip empty or title-duplicated body on list cards. */
export function hasMeaningfulNoticeBody(
  body: string,
  title: string
): boolean {
  const b = htmlToPlainText(body || "").trim();
  if (!b) return false;
  const t = (title || "").trim();
  if (t && b === t) return false;
  return true;
}
